/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";

import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Menu,
  MenuItem,
  Switch,
} from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import NotificationItem from "examples/Items/NotificationItem";
import debounce from "lodash.debounce";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { exportToExcel } from "utilities";
import { NumberFormatter } from "utilities";
import { fairStatus } from "utilities";
import { statusColors } from "utilities";
import AddUser from "layouts/user/add-user";
import { notify } from "utilities";
import { deleteUser } from "api";
import { getAllUser } from "api";
import { getAllLocation } from "api";
import { getAllLocationList } from "api";
import { updateUser } from "api";

// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";

export default function data({ fair, locationData }) {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);

  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState();
  const [loadingId, setLoadingId] = useState(null);

  const [openConfirm, setOpenConfirm] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [showAdd, setShowAdd] = useState(false);
  const [userData, setUserData] = useState();

  const arrStatus = [
    { key: "all", name: "All" },
    { key: "active", name: "Active" },
    { key: "inactive", name: "Inactive" },
  ];

  const [status, setStatus] = useState(arrStatus[0]);
  const [arrLocation, setArrLocation] = useState([{ _id: 0, name: "All" }]);
  const [location, setLocation] = useState(arrLocation[0]);

  const lastSearch = useRef("");
  const isFetching = useRef(false);
  const lastApiParams = useRef("");
  const resizeTimeout = useRef(null);
  const didMount = useRef(false);
  const isFirstLoad = useRef(true);

  // useEffect(() => {}, [loadingId]);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimeout.current);
      resizeTimeout.current = setTimeout(() => {
        // do nothing → just absorb resize re-renders
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (didMount.current) return;

    didMount.current = true;

    getAllUserApi();
    getAllLocationApi();
  }, []);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    getAllUserApi();
  }, [search]);

  const debouncedFetch = useMemo(
    () =>
      debounce((searchVal) => {
        setSearch(searchVal);
      }, 500),
    []
  );

  useEffect(() => {
    return () => {
      debouncedFetch.cancel();
    };
  }, [debouncedFetch]);

  useEffect(() => {
    getAllUserApi();
  }, [page]);

  const getAllUserApi = (isReset = false, isExport = false) => {
    var params = {
      page: page,
      limit: limit,
      name: search,
      fair: fair?._id,
      isExport: isExport,
    };

    if (isReset) {
      params.location = "all";
      params.status = "all";
    } else {
      params.location = location?._id || "all";
      params.status = status?.key || "all";
    }

    const key = JSON.stringify(params);
    // 🚀 BLOCK if same API already called
    if (lastApiParams.current === key) return;

    lastApiParams.current = key;

    if (isFetching.current) return; // 🚀 BLOCK duplicate calls
    isFetching.current = true;

    setLoading(true);

    getAllUser({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            if (isExport) {
              const dataList = responseJson?.location;
              exportToExcel(dataList, "user.xlsx");
            } else {
              setList(responseJson?.location);
              setTotal(responseJson?.total || 0);
            }
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
        isFetching.current = false;
      });
  };

  const getAllLocationApi = () => {
    var params = {
      page: 1,
      limit: 1000,
      fair: fair?._id,
    };

    getAllLocationList({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrLocation([{ _id: 0, name: "All" }, ...responseJson?.location]);
            if (locationData) {
              setLocation(responseJson?.location.find((loc) => loc._id === locationData?._id));
            }
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const onSearchData = (val) => {
    if (lastSearch.current === val) return; // 🚀 STOP duplicate
    lastSearch.current = val;
    setPage(1);
    debouncedFetch(val);
  };

  const handleAction = (event, rowId) => {
    setMenuAnchor(event.currentTarget);
    setCurrentRowId(rowId);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const onPressAdd = () => {
    setCurrentRowId(null);
    setUserData();
    setShowAdd(true);
  };

  const onSubmitAddUser = () => {
    setShowAdd(false);
    getAllUserApi();
  };

  const columns = useMemo(() => {
    return [
      { Header: "name", accessor: "name", align: "left" },
      { Header: "phone", accessor: "phone", align: "center" },
      { Header: "role", accessor: "role", align: "center" },
      {
        Header: "location access",
        accessor: "locationAccess",
        align: "center",
      },
      {
        Header: "status",
        accessor: "status",
        align: "center",
      },
      {
        Header: "actions",
        accessor: "actions",
        align: "center",
      },
    ];
  }, []);

  const handleStatus = (item) => {
    setLoadingId(item?._id);
    var params = {
      isActive: item?.isActive ? false : true,
    };
    updateUserApi(params, item._id);

    // const updatedUsers = list.map((u) => (u._id === user.id ? { ...u, isActive: !u.isActive } : u));
    // setList(updatedUsers);
  };

  const updateUserApi = (params, id) => {
    updateUser({
      params: params,
      id: id,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            // notify();
            getAllUserApi();
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoadingId(null);
      });
  };

  const confirmDialog = () => {
    return (
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this user? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="error" variant="contained">
            Cancel
          </Button>
          <MDButton onClick={handleDelete} color="error">
            Delete
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const handleDelete = () => {
    setOpenConfirm(false);

    deleteUserApi();
  };

  const deleteUserApi = () => {
    var params = {};

    deleteUser({
      params: params,
      id: currentRowId,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            getAllUserApi();
          }
        }
      })
      .catch((e) => {});
  };

  const oneEditClick = () => {
    closeMenu();
    setUserData(list.find((item) => item._id === currentRowId));
    setShowAdd(true);
  };
  const onDeleteClick = () => {
    // Implement delete functionality here
    closeMenu();
    setOpenConfirm(true);
  };

  const renderActionMenu = (rowId) => (
    <Menu
      id={`simple-menu-${rowId}`}
      anchorEl={menuAnchor}
      anchorReference={null}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={Boolean(menuAnchor) && currentRowId === rowId}
      onClose={closeMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>mode_edit</Icon>} title="Edit" onClick={oneEditClick} />
      <NotificationItem
        icon={<Icon>delete</Icon>}
        title={
          <>
            <span style={{ color: "red" }}>Delete</span>
          </>
        }
        onClick={onDeleteClick}
      />
    </Menu>
  );

  const rows = useMemo(() => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: (
          <MDBox>
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              noWrap
              sx={{
                maxWidth: "350px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item?.user?.name}
            </MDTypography>
          </MDBox>
        ),
        phone: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography display="block" variant="caption" noWrap>
              {item?.user?.code} {item?.user?.phone}
            </MDTypography>
          </MDBox>
        ),
        role: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography display="block" variant="caption" noWrap>
              {item?.role}
            </MDTypography>
          </MDBox>
        ),
        locationAccess: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography
              variant="caption"
              display="block"
              sx={{
                minWidth: "250px",
                maxWidth: "250px",
              }}
            >
              {item?.location.map((i) => i.name).join(", ")}
            </MDTypography>
          </MDBox>
        ),
        status: (
          <MDBox sx={{ px: 1 }}>
            {loadingId === item?._id ? (
              <CircularProgress size={24} color="info" />
            ) : (
              <Switch
                checked={item?.isActive}
                onChange={() => handleStatus(item)}
                color="success"
              />
            )}
          </MDBox>
        ),
        actions: (
          <MDBox sx={{ px: 1 }} onClick={(e) => handleAction(e, item?._id)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">more_vert</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  }, [list]);

  const handleApplyFilter = () => {
    if (page === 1) {
      getAllUserApi();
    } else {
      setPage(1);
    }
  };
  const handleResetFilter = useCallback(() => {
    setStatus(arrStatus[0]);
    setLocation(arrLocation[0]);
    // setIndustry(arrIndustry[0]);
    // setLocation(arrLocation[0]);
    // setSponsor(arrSponsor[0]);

    getAllUserApi(true);
  }, [arrLocation, arrStatus]);

  const handleExport = () => {
    getAllUserApi(false, true);
    // exportToExcel(list, "user.xlsx");
  };

  const ViewFilter = () => {
    return (
      <Card sx={{ mb: 3 }}>
        <MDBox
          p={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          gap={2}
        >
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Status"
              value={JSON.stringify(status)}
              onChange={(e) => setStatus(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrStatus.map((item, index) => (
                <MenuItem key={index} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Location Access"
              value={JSON.stringify(location)}
              onChange={(e) => setLocation(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrLocation.map((item, index) => (
                <MenuItem key={index} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
        </MDBox>
        <MDBox
          mb={3}
          ml={3}
          mr={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          gap={2}
        >
          <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
            <MDButton onClick={handleApplyFilter} variant="gradient" color="info">
              apply
            </MDButton>
            <Button onClick={handleResetFilter} color="error" variant="contained">
              reset
            </Button>
          </MDBox>
          <MDButton onClick={handleExport} color="secondary" variant="contained">
            export
          </MDButton>
        </MDBox>
      </Card>
    );
  };

  return (
    <MDBox>
      <ViewFilter />

      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={true}
            canSearch={true}
            onSearch={onSearchData}
            page={page}
            limit={limit}
            total={total}
            onPageChange={(newPage) => setPage(newPage)}
            canAdd={{
              onClick: onPressAdd,
              label: "Add",
            }}
          />
          {list.map((item) => renderActionMenu(item?._id))}

          {/* {confirmDialogAdd()} */}

          {confirmDialog()}

          {showAdd && (
            <AddUser
              visible={showAdd}
              userData={userData}
              fairData={fair}
              onClose={() => {
                setShowAdd(false);
              }}
              onSubmit={onSubmitAddUser}
            ></AddUser>
          )}

          {loading && (
            <MDBox display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="info" />
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
